var _window$SharedWorker;
import { replaceCDNToOrigin } from './tenant/replace-cdn-to-origin';
import { SharedWorkerPolyfill } from './fallback-shared-worker';
export class SharedWorker extends ((_window$SharedWorker = window.SharedWorker) !== null && _window$SharedWorker !== void 0 ? _window$SharedWorker : SharedWorkerPolyfill) {
  constructor(url, options) {
    const sameOriginWorkerUrl = replaceCDNToOrigin(url);
    super(sameOriginWorkerUrl, options);
  }
}